<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>Database Functions</h3>
            </b-col>
        </b-row>

        <b-row>
            <button style="font-size:20px" @click="getFiles()" :disabled="download_in_progress">
                Download user table <i class="fa fa-download"></i>
            </button>
        </b-row>
    </b-container>
</template>


<script>
import Alert from '../components/alert.vue';

export default {
    data: function () {
        return {
            message: '',
            download_in_progress: false
        }
    },
    methods: {
        getFiles() {
            this.download_in_progress = true;
            this.$http.get(this.$apiURL + '/database_retrieve', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    const today = new Date();
                    const dateTime = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
                    var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'user_table_' + dateTime + '.csv');
                    document.body.appendChild(fileLink);

                    fileLink.click();

                })
                .catch((error) => {
                    this.message = error.response.data
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.download_in_progress = false;
                });;
        },
    },
    components: {
        alert: Alert,
    },
};
</script>